<div class="not-found">
    <div class="error">
        <img class="error__image" src="../../../resources/images/not-found.png" alt="Error">
    </div>
    <h3>Sorry, we could not find your page</h3>
</div>
